import React from "react";
import { FormGroup, FormControlLabel } from "@material-ui/core";
import { useStyles } from "./DateRangeGroup.styles";
import { getDateRangeName } from "./DateRangeGroup.utils";
import { Calendar } from "./Calendar";
import { Radio } from "./Radio";
import type { IDateRangeGroupProps } from "./DateRangeGroup.types";

export function DateRangeGroup<T extends string | number | unknown = unknown>(props: IDateRangeGroupProps<T>) {
  const classes = useStyles();
  const { items, dateRange } = props;
  const { checked, onChangeChecked, value, onChange, hiddenRadio } = props;

  const disabled = items.length === 0;
  const labelGroup = getDateRangeName(dateRange);

  return (
    <FormGroup>
      <FormControlLabel
        disabled={disabled}
        control={hiddenRadio === true ? <></> : <Radio checked={checked} onChangeChecked={onChangeChecked} disabled={disabled} />}
        label={
          <div className={classes.labelCheck} onClick={(e) => e.preventDefault()}>
            <span className={classes.labelGroup}>{labelGroup}</span>
            <Calendar items={items} disabled={disabled} dateRange={dateRange} value={value} onChange={onChange} />
          </div>
        }
      />
    </FormGroup>
  );
};
